SNI.Application.addModule('super-lead-hero', (context) => {
  'use strict';

  return {
    behaviors: ['lazy-load'],
  };
});
